import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ForecastingUiContext = createContext(null);

export const ForecastingUiProvider = ({ children }) => {
  // Controls (FY + retailer) published by the Forecasting page so the nav item can host them.
  // null whenever the Forecasting page is not mounted.
  const [forecastNavControls, setForecastNavControls] = useState(null);

  const registerForecastNavControls = useCallback((controls) => {
    setForecastNavControls(controls);
  }, []);

  const clearForecastNavControls = useCallback(() => {
    setForecastNavControls(null);
  }, []);

  const value = useMemo(
    () => ({
      forecastNavControls,
      registerForecastNavControls,
      clearForecastNavControls,
    }),
    [forecastNavControls, registerForecastNavControls, clearForecastNavControls],
  );

  return <ForecastingUiContext.Provider value={value}>{children}</ForecastingUiContext.Provider>;
};

export const useForecastingUi = () => {
  const context = useContext(ForecastingUiContext);

  if (!context) {
    throw new Error('useForecastingUi must be used within a ForecastingUiProvider');
  }

  return context;
};
